<adm-type-ahead-selector2
  label="Vælg organisation"
  [required]="required()"
  [fetchFn]="fetchOrganizations"
  [fetchByIdFn]="fetchOrganizationById"
  [initialId]="initialId()?.toString()"
  (itemSelected)="organizationSelected($event)"
  identityPropertyName="id"
  [disabled]="disabled()"
  [validationControl]="validationControl()"
  [requiredErrorText]="requiredErrorText()"
  (clearTypeAhead)="clearTypeAhead.emit()"
  [resetTrigger]="resetTrigger()" />
